var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end align-items-center"},[_c('ul',{staticClass:"pagination pagination-rounded mb-0"},[_c('b-pagination',_vm._g(_vm._b({ref:"pagination"},'b-pagination',_vm.$attrs,false),_vm.$listeners))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }